// src/lib/analytics.js
// Thin, SSR/prerender-safe wrapper around the GTM dataLayer.
//
// The GTM container (GTM-MZJPZ5FZ) is loaded in public/index.html; this helper
// only pushes custom conversion events that GTM triggers/tags can consume.
//
// Privacy: no PII is pushed here (no name, e-mail or phone) — only categorical
// conversion signals (event name, location, fleet size, estimated savings).
// GTM governs whether downstream tags fire, respecting the consent model.

// Google Ads conversion labels — the GTM container has no triggers for our
// custom events, so critical conversions are fired straight at the Ads tag
// (AW-17674238008 loads independently in public/index.html).
// Paste the `send_to` value from Ads UI → Goals → Conversions → <action> →
// Tag setup → event snippet. Empty string = no direct Ads conversion.
const ADS_CONVERSION_LABELS = {
  lead_submit: '', // "Submit lead form"
  roi_lead_submit: '', // same action (or its own if created separately)
  phone_click: '', // optional: click-to-call conversion
};

/**
 * Push a custom event onto the GTM dataLayer.
 * Safe to call during react-snap prerender (no-op when window is absent).
 *
 * @param {string} event             Event name, e.g. 'roi_lead_submit'
 * @param {Record<string, unknown>} [params]  Non-PII event parameters
 */
export function trackEvent(event, params = {}) {
  if (typeof window === 'undefined') return; // react-snap / SSR guard
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });

  const sendTo = ADS_CONVERSION_LABELS[event];
  if (sendTo && typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', { send_to: sendTo });
  }
}
